<div class="dialog">
  <div mat-dialog-header class="header fw-700"> Assign Programs
    <button class="close-button" (click)="onCancel()" disableRipple>
      <span class="material-symbols-outlined"> close </span>
    </button>
  </div>
  <hr>
  <mat-dialog-content>
    <div class="body-header fw-700"> Program Name :<span class="fw-400"> {{this.programName}} </span></div>
    <div class="search-container">
      <div class="input-wrapper">
        <div class="search-bar">
          <input class="form-control input-styling"
            placeholder="Search by ID or Name" aria-label="Number" class="form-control" matinput="" type="text"
            [(ngModel)]="searchText" (keyup)="applyFilter()">
          <button type="submit" class="msicon append_button">
            <span class="material-symbols-outlined">search</span>
          </button>
        </div>
      </div>
      <button class="custom_btn primary_btn_base" (click)="AssignUsers()"> Assign
      </button>
    </div>

    <div class="data-grid">
      <mat-table [dataSource]="dataSource" matSort class="employees-table">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox color="primary" (change)="toggleAllRows($event)" [checked]="isAllSelected()"
              [indeterminate]="isIndeterminate()" [disabled]="!hasSelectableRows()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox color="primary" (change)="toggleSelection(row)" [checked]="isSelected(row)"
              [disabled]="isCheckboxDisabled(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <!-- ID Column -->
        <ng-container matColumnDef="employeeId">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Employee ID </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.employeeId }} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="employeeName">
          <mat-header-cell *matHeaderCellDef> Employee Name </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="ellipsis">
              {{ row.employeeName ?? "" }}
            </div>
          </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef> Email ID </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span class="ellipsis" matTooltip="{{ row.emailAddress }}" matTooltipPosition="above">
              {{ row.emailAddress }}
            </span>
          </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef> Status
            <button class="filter-button" [matMenuTriggerFor]="statusFilterMenu">
              <span class="material-symbols-outlined filter-icon">filter_alt</span>
            </button>
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.status }} </mat-cell>
        </ng-container>

        <mat-menu #statusFilterMenu="matMenu">
          <div class="status-filter-checkboxes">
            <mat-checkbox color="primary" *ngFor="let status of filterStatus" [(ngModel)]="status.checked"
              class="status-filter-checkbox" (click)="$event.stopPropagation()">
              {{ status.label }}
            </mat-checkbox>
          </div>
          <div class="status-filter-actions">
            <button mat-button (click)="clearStatusFilter(); statusFilterMenu?.closeMenu()"
              class="btn btn-outline btn-spacing" style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">
              Clear
            </button>
            <button mat-flat-button color="primary" (click)="applyStatusFilter(); statusFilterMenu?.closeMenu()"
              class="btn btn-primary" style="background: #1976D2; color: white;">
              Apply
            </button>
          </div>
        </mat-menu>


        <!-- Add these two lines -->
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row [class.odd]="i % 2 == 1" [class.even]="i % 2 == 0"
          *matRowDef="let row; columns: displayedColumns; let i = index;">
        </mat-row>
      </mat-table>

      <div *ngIf="dataSource?.filteredData?.length == 0" class="no-records-container">
        <div class="no-records">
          <img src="../../../assets/images/no_data.png" height="120px"><br>
          <span class="mt-3 d-block"> No records found for the search criteria </span>
        </div>
      </div>

      <!-- Pagination -->
      <mat-paginator [length]="totalRecords" [pageSize]="5" [pageSizeOptions]="[5,10,20,40,50,60]"
        aria-label="Select page" (page)="getPaginatorData($event)"
        style="background: inherit; width: 98%; margin-left: 16px;"></mat-paginator>
    </div>
  </mat-dialog-content>
</div>